// extracted by mini-css-extract-plugin
export var activeFilterButton = "_pl-c";
export var backButton = "_pl-4";
export var backIcon = "_pl-5";
export var chevronShortcut = "_pl-6";
export var container = "_pl-1";
export var editor = "_pl-8";
export var editorWrapper = "_pl-7";
export var prefix = "_pl-2";
export var searchIcon = "_pl-3";
export var suffix = "_pl-9";
export var suffixContent = "_pl-a";
export var suffixText = "_pl-b";
export var wrapper = "_pl-0";